export const initiateIntersectionObserver = () => {
  let options = {
    root: null,
    rootMargin: '0px',
    threshold: [0.25, 0.5, 0.75, 0.8, 0.85, 0.95],
  }
  let callback = entries => {
    console.log('ENTRIES', entries.length)

    entries.forEach(entry => {
      console.log(entry.target.id)
      if (
        entry.isIntersecting &&
        entry.intersectionRatio >= 0.5 &&
        entry.time > 2000 &&
        !entry.target.classList.contains('animateForward')
      ) {
        entry.target.classList.add('animateForward')
      }
      // else {
      //   entry.target.classList.remove('animateForward')
      // }
    })
  }
  let observer = new IntersectionObserver(callback, options)

  return function(targetSelector) {
    let target = document.querySelector(targetSelector)
    console.log('TARGET', target)
    observer.observe(target)
  }
}
